import global from "../config/global";
import SSEConstant from "./const/SSEConstant";
import SSEPushListener from "./listener/SSEPushListener";
import SSEO2OListener from "./listener/SSEO2OListener";
import SSEMBListener from "./listener/SSEMBListener";

export function resolvePush(dataRsp,pageTarget){
  switch (dataRsp.opCode){
    case SSEConstant.OpCode.Account:break
    case SSEConstant.OpCode.O2O:
      new SSEO2OListener(pageTarget).onReceivePush(dataRsp)
      break
    case SSEConstant.OpCode.Push:
      new SSEPushListener(pageTarget).onReceivePush(dataRsp)
      break
    case SSEConstant.OpCode.Multi:
      new SSEMBListener(pageTarget).onReceivePush(dataRsp);
      break
    case SSEConstant.OpCode.Video:
      break
  }

}



// WEBPACK FOOTER //
// ./src/push/SSEPushReceiver.js